import React from "react";
import { useLoanModal } from "../../context/loan-modal-context";

const loanProducts = [
  {
    id: 1,
    title: "Personal Loan",
    description: "For your personal financial needs",
    color: "var(--card-green)",
    link: "/contact",
    icon: (
      <svg
        className="h-7 w-7 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2a5 5 0 0 1 5 5v1a5 5 0 0 1-10 0V7a5 5 0 0 1 5-5z" />
        <path d="M20 21a8 8 0 1 0-16 0" />
      </svg>
    ),
    benefits: [
      "Quick Approval",
      "Flexible Repayment",
      "Minimal Documents",
    ],
  },
  {
    id: 2,
    title: "Business Loan",
    description: "Fuel your business growth",
    color: "var(--card-blue)",
    link: "/loan-products",
    icon: (
      <svg
        className="h-7 w-7 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    ),
    benefits: [
      "Working Capital",
      "Business Expansion",
      "Equipment Purchase",
    ],
  },
  {
    id: 3,
    title: "Loan Against Property",
    description: "Unlock the value of your property",
    color: "var(--card-orange)",
    link: "/loan-products",
    icon: (
      <svg
        className="h-7 w-7 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
    benefits: [
      "High Loan Amount",
      "Low Interest Rates",
      "Flexible Tenure",
    ],
  },
  {
    id: 4,
    title: "Gold Loan",
    description: "Turn your gold into instant funds",
    color: "var(--card-gold)",
    link: "/contact",
    icon: (
      <svg
        className="h-7 w-7 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="9" cy="9" r="6" />
        <circle cx="15" cy="15" r="6" />
        <path d="M15 9l-6 6" />
      </svg>
    ),
    benefits: [
      "Quick Processing",
      "Minimal Documents",
      "Safe & Secure",
    ],
  },
  {
    id: 5,
    title: "EV Loan",
    description: "Make your switch to electric easier",
    color: "var(--card-purple)",
    link: "/contact",
    icon: (
      <svg
        className="h-7 w-7 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.5 2.8C2.1 10.7 2 10.9 2 11.1V16c0 .6.4 1 1 1h2" />
        <circle cx="7" cy="17" r="2" />
        <path d="M9 17h6" />
        <circle cx="17" cy="17" r="2" />
        <path d="M13 3l-2 4h3l-2 4" />
      </svg>
    ),
    benefits: [
      "Best Interest Rates",
      "Flexible Tenure",
      "Quick Approval",
    ],
  },
];

function PopularLoans() {
  const { openLoanModal } = useLoanModal();

  return (
    <section id="popular-loans" className="overflow-hidden bg-white section-spacing">
      <div className="section-container">
        
        {/* ================= SECTION HEADER ================= */}
        <div className="text-center max-w-[700px] mx-auto">
          <p className="font-jakarta text-[11px] font-medium tracking-[0.34em] text-[var(--hero-green)] sm:text-[12px] uppercase mb-2.5">
            OUR LOAN PRODUCTS
          </p>
          <h2 className="font-bricolage text-[32px] sm:text-[38px] md:text-[42px] font-bold leading-[1.1] tracking-[-1.2px] text-[#111827]">
            Our Popular Loan <span className="text-[var(--hero-green)]">Products</span>
          </h2>
          <p className="mt-3 font-jakarta text-[15px] sm:text-[16px] leading-[1.6] text-[#556369]">
            Choose from a wide range of loan options tailored for your needs
          </p>
        </div>

        {/* ================= 5 PRODUCT CARDS GRID ================= */}
        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 sm:gap-5 xl:gap-6">
          {loanProducts.map((product) => (
            <div
              key={product.id}
              className="group relative flex flex-col justify-between rounded-[20px] border border-[#e5e7eb] bg-white p-6 shadow-[0_4px_20px_rgba(0,0,0,0.03)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_18px_36px_rgba(0,0,0,0.08)] hover:border-[#d1d5db]"
            >
              <div>
                {/* Top Balanced Round Circular Icon Badge */}
                <div className="flex justify-center">
                  <div
                    className="flex h-14 w-14 items-center justify-center rounded-full shadow-sm transition-transform duration-300 group-hover:scale-105"
                    style={{ backgroundColor: product.color }}
                  >
                    {product.icon}
                  </div>
                </div>

                {/* Title */}
                <h3 className="mt-5 text-center font-bricolage text-[20px] font-bold leading-tight tracking-[-0.6px] text-[#111827]">
                  {product.title}
                </h3>

                {/* Description */}
                <p className="mt-2 min-h-[38px] text-center font-jakarta text-[13px] font-normal leading-[1.5] text-[#6b7280]">
                  {product.description}
                </p>

                {/* Benefits List with Green Checks */}
                <ul className="mt-6 space-y-3 border-t border-[#f3f4f6] pt-5">
                  {product.benefits.map((benefit, bIdx) => (
                    <li
                      key={bIdx}
                      className="flex items-center gap-2.5 font-jakarta text-[13px] font-medium text-[#374151]"
                    >
                      <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-[#e8f5e9] text-[11px] font-bold text-[#008751]">
                        ✓
                      </span>
                      <span className="truncate">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Bottom Action Button Triggering Popup with Product Name */}
              <div className="mt-7 pt-2">
                <button
                  type="button"
                  onClick={() => openLoanModal(product.title)}
                  style={{ backgroundColor: product.color }}
                  className="flex w-full items-center justify-center gap-1.5 rounded-xl py-3 font-jakarta text-[14px] font-semibold text-white shadow-xs transition-all duration-200 hover:brightness-105 hover:shadow-md outline-none focus:outline-none cursor-pointer"
                >
                  Apply Now →
                </button>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default PopularLoans;
